export default "__VITE_ASSET__D331D_JM__"